<template>
    <Card style="width: 100%;">
        <p slot="title">
            <Icon type="md-filing" />
            操作记录
        </p>
        <template v-if="page && page.length > 0">
            <p v-for="(el, i) in page" :key="i">
                {{el}}
            </p>
        </template>
        <p v-else>
            暂无记录
        </p>
    </Card>
</template>
<script>
    /**
     * 关键词的输入
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    export default {
        name: 'LyLog',
        mixins: [CompEventMixin],
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        }
    }
</script>




// WEBPACK FOOTER //
// ../projectCore/src/components/log/src/index.vue